import { Component, OnInit } from '@angular/core';
import { TaskComponent } from '../task/task.component';
import { Equation } from '../../DBEquation';

@Component({
  selector: 'app-task-fraction-comparison',
  templateUrl: './task-fraction-comparison.component.html',
  styleUrls: ['./task-fraction-comparison.component.css']
})
export class TaskFractionComparisonComponent extends TaskComponent {
  public name = "TaskFractionComparison";

  public equation;
  ngOnChanges() {
    this.equation = new Equation(this.task.first + '§comparison[guess]' + this.task.second, this.task);
  }

}